class ProductAccordionCarla {
  static duration = 300;

  static init() {
    document.querySelectorAll('details.product-accordion-carla').forEach((details) => {
      if (details.dataset.accordionInit) return;
      details.dataset.accordionInit = 'true';

      const summary = details.querySelector('summary');
      const panel = details.querySelector('.product-accordion-carla__panel');
      if (!summary || !panel) return;

      if (details.open) {
        panel.style.height = 'auto';
      }

      summary.addEventListener('click', (event) => {
        event.preventDefault();

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          details.open = !details.open;
          panel.style.height = details.open ? 'auto' : '0px';
          return;
        }

        if (details.open) {
          ProductAccordionCarla.close(details, panel);
        } else {
          ProductAccordionCarla.open(details, panel);
        }
      });
    });
  }

  static open(details, panel) {
    details.open = true;
    panel.style.overflow = 'hidden';
    panel.style.height = '0px';

    window.requestAnimationFrame(() => {
      panel.style.transition = `height ${ProductAccordionCarla.duration}ms ease`;
      panel.style.height = `${panel.scrollHeight}px`;

      const onEnd = (event) => {
        if (event.propertyName !== 'height') return;
        panel.style.height = 'auto';
        panel.style.overflow = '';
        panel.style.transition = '';
        panel.removeEventListener('transitionend', onEnd);
      };

      panel.addEventListener('transitionend', onEnd);
    });
  }

  static close(details, panel) {
    panel.style.overflow = 'hidden';
    panel.style.height = `${panel.scrollHeight}px`;

    window.requestAnimationFrame(() => {
      panel.style.transition = `height ${ProductAccordionCarla.duration}ms ease`;
      panel.style.height = '0px';

      const onEnd = (event) => {
        if (event.propertyName !== 'height') return;
        details.open = false;
        panel.style.height = '0px';
        panel.style.overflow = '';
        panel.style.transition = '';
        panel.removeEventListener('transitionend', onEnd);
      };

      panel.addEventListener('transitionend', onEnd);
    });
  }
}

function initProductAccordionCarla() {
  ProductAccordionCarla.init();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductAccordionCarla);
} else {
  initProductAccordionCarla();
}

document.addEventListener('shopify:section:load', initProductAccordionCarla);
